import { Box, Button, DismissIcon, Flex } from '@iheartjane/reefer';
import type { ReactNode } from 'react';
import { useContext } from 'react';

import styles from './prompt.module.css';
import { PromptContext } from './promptContext';

export const PromptContent = ({ children }: { children: ReactNode }) => {
  const { dismissible, dismissPrompt } = useContext(PromptContext);

  return (
    <Flex
      border="grays-light"
      background="grays-white"
      borderRadius="lg"
      p={24}
      alignItems="center"
    >
      {/* The "Arrow" is a diamond and this Box hides the bottom half */}
      <Box
        overflow="hidden"
        position="absolute"
        top={-6.5}
        right={150}
        height={7.5}
        width={15}
        zIndex="var(--layers-popover)"
      >
        <div className={styles['promptArrow']} />
      </Box>

      {children}

      {dismissible && (
        <Button.Icon
          icon={<DismissIcon size="lg" altText="dismiss login prompt" />}
          onClick={dismissPrompt}
          className={styles['dismissButton']}
        />
      )}
    </Flex>
  );
};
